//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { LocationAddressUpdateItem } from './LocationAddressUpdateItem';
import { LocationAddressType, WhiteboardSpaceMode } from './Enums';

export class PencilSpacesAddressUpdateItem extends LocationAddressUpdateItem {
    override readonly AddressType: LocationAddressType = LocationAddressType.PencilSpaces;
    ApiKey?: string | null;
    SpaceMode?: WhiteboardSpaceMode;

    constructor(initializer?: Partial<Omit<PencilSpacesAddressUpdateItem, "AddressType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "PencilSpacesAddressUpdateItem";
}
